export { default as ModelViewerLifestylePromptCard } from './ModelViewerLifestylePromptCard';
